<template>
  <div class="pos-relative">
    <span
      :class="[
        'mobile-label',
         language === 'he' ? 'mobile-label-he' : 'mobile-label-en',
        actionType === 'add' && required && 'required-field',
        isPhoneNumberActive && 'mobile-label-active',
        disabled && 'low-op-disabeld',
        isHideMobileTitle && 'op-0',
      ]"
    >
      {{ title ? title : $t('Mobile') }}
    </span>
    <vue-tel-input
      v-model="parentObject[field ? field : 'phoneNumber']"
      validCharactersOnly
      disabledFetchingCountry
      defaultCountry="IL"
      :wrapperClasses="[
        isHideDropdown && 'phone-input-without-dropdown',
        'phone-wrapper',
      ]"
      :style="{ width: width }"
      :inputClasses="[
        isPhoneNumberActive ? 'phone-input-active' : 'phone-input',
        isHideUnderline && 'no-underline ',
      ]"
      :disabled="disabled"
      :inputOptions="inputOptions"
      mode="international"
      :placeholder="placeholder ? placeholder : 'Enter phone number'"
      @focus="() => (isPhoneNumberActive = true)"
      @blur="() => (isPhoneNumberActive = false)"
    ></vue-tel-input>
  </div>
</template>

<script>
import { VueTelInput } from 'vue-tel-input'
import { mapGetters } from 'vuex';

export default {
  name: 'PhoneNumberInput',
  data() {
    return {
      isPhoneNumberActive: false,
      inputOptions: {
        showDialCode: true,
      },
    }
  },
  props: {
    required: Boolean,
    placeholder: String,
    title: {
      type: String,
default: '',
    } ,
    parentObject: Object,
    disabled: {
      type: Boolean,
      default: false,
    },
    actionType: String,
    isHideDropdown: {
      type: Boolean,
      default: false,
    },
    width: {
      type: String,
      default: '250px',
    },
    isHideMobileTitle: {
      type: Boolean,
      default: false,
    },
    isHideUnderline: {
      type: Boolean,
      default: false,
    },
    field: {
      type: String,
default: '',
    } 
  },
  components: { VueTelInput },
  computed: {
    ...mapGetters(['language']),
  },
}
</script>

<style src="./PhoneNumberInput.css"></style>
